<div class="animation" #container [@display]="state">
    <app-cityscape-scroll-animation></app-cityscape-scroll-animation>
    <div class="progress-container">
        <div class="truck" [style.left]="state == 'busy' ? (progress * 0.8) + '%' : '-100px'">
            <fa-icon [icon]="truckIcon" size="4x" class="accent-color"></fa-icon>
        </div>
    </div>
</div>

